import {ENDPOINTS, buildUrl} from '@/api/endpoints.js';

export const createContestStream = (contestId) => {
    const url = buildUrl(ENDPOINTS.PUBLIC.STREAM(contestId));
    console.log(`🔌 Stream Service: Connecting to ${url}`);
    return new EventSource(url);
};